export default "__VITE_ASSET__NZyRFD0O__"